import { HttpErrorResponse } from '@angular/common/http';
import { CreateStaticLinkSessionResponse } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const StaticPaymentLinkLandingComponentActions = createActionGroup({
  source: 'Static Payment Link Landing Component',
  events: {
    Initialize: props<{ supplierName: string; templateName: string }>(),

    'Create Static Link Session Success': props<{
      response: CreateStaticLinkSessionResponse;
    }>(),

    'Create Static Link Session Error': props<{ error: HttpErrorResponse }>(),

    'Verify User Is Provisioned Success': emptyProps(),

    'Verify User Is Provisioned Error': props<{ error: HttpErrorResponse }>(),
  },
});
